export default "/images/vendor/flag-icons/flags/4x3/rs.svg?23ed750733e58c9d9091bdb659acb054";